import { useHistory } from "react-router-dom";
import ReactTooltip from "react-tooltip";
import { useRecoilState, useRecoilValue } from "recoil";
import { EmployeeTabs } from "../../../EmployeeTab/EmployeeTab";
import { permissionsSelector } from "../../../Login/selectors/permissionSelector";
import { OfficeTabs } from "../../../OfficeTab/OfficeTabs";
import { PERMISSIONS } from "../../../PermissionsConstants";
import { mainSelectedTab } from "../../atoms";
import { useRef, useEffect } from "react";

const getFallback = () => (
  <span className="undefineTextColor">unspecified</span>
);

const getValue = (val) => val || getFallback();
const getListValue = (val) => {
  if (!val) {
    return getFallback();
  }
  return String(val).replaceAll(/,/g, ", ");
};

const getActiveState = (val) =>
  (val && val === "Active") || val === true ? "True" : "False";

const getSuspendedState = (val) => (val && val === true ? "True" : "False");

const getProductionState = (val) =>
  (val && val === "Active") || val === true ? "True" : "False";

const getCarrierStatusLabel = (val) =>
  val === true || val === "Active" ? (
    <span className="text-black font-bold">Active</span>
  ) : (
    <span className="text-black font-bold">Inactive</span>
  );

const getCodeStatus = (val) => (val ? "Active" : "Inactive");

const getDistributionChannel = (data) => {
  if (data.distributionChannel || data.officeTypeName) {
    return data.isFranchise === true
      ? data.officeTypeName
      : data.distributionChannel;
  }
  return getFallback();
};

const getCdrcStatus = (data) => {
  if (data.cdrcStatus === "True" && data.isCdrcOfficeMismatch) {
    return "True - Office Mismatch";
  }

  return data.cdrcStatus;
};

const getDateValue = (date) =>
  date ? new Date(date).toLocaleDateString() : getFallback();

const getExecutionDate = (date) => (date ? date.split(" ")[0] : getFallback());

const getPreNotes = (notes) =>
  notes ? (
    <pre lang="en" className="whitespace-pre-wrap break-words hyphens-auto">
      {notes}
    </pre>
  ) : (
    getFallback()
  );

const getSimplePreNotes = (notes) =>
  notes ? <pre>{notes}</pre> : getFallback();

export const ProdCodeExpandedModal = ({ data, tableRef }) => {
  const canSellRef = useRef<HTMLDivElement>(null);
  const userPermissions = useRecoilValue(permissionsSelector);
  const viewPermissionEmp =
    PERMISSIONS.permission_carrieragreemnentmgmt_employee_view;
  const history = useHistory();
  const [, setSelectedIndex] = useRecoilState(mainSelectedTab);

  useEffect(() => {
    ReactTooltip.rebuild();
  }, [data]);

  const renderProducerContent = () => {
    if (!data.producerName || data.producerName === "") {
      return getFallback();
    }

    if (userPermissions.includes(viewPermissionEmp)) {
      return (
        <button
          className="cursor-pointer bg-transparent border-none p-0 m-0 text-left"
          onClick={() => {
            onClickHandleLink("producerName", data);
          }}
          type="button"
          tabIndex={0}
        >
          <span className="font-bold-400 uppercase">
            <span className="text-left underline text-blue-500">
              {data.producerName}
            </span>
          </span>
        </button>
      );
    }

    return (
      <div
        data-tip="Contact your System Administrator to secure access to employee module."
        className="cursor-pointer"
      >
        <span>{data.producerName}</span>
      </div>
    );
  };

  const onClickHandleLink = (fieldName, data) => {
    const url =
      fieldName === "producerName"
        ? "/employeetab/employee"
        : "/officesettings/officesetting";
    const redirectState =
      fieldName === "producerName"
        ? {
            pathname: url,
            employeeId: data.producer,
            masterCarrierId: data.masterCarrierID,
            prodCodeId: data.carrierProducerCodeId,
            action: "Producer",
          }
        : {
            officeCode: data.officeCode,
            masterCarrierId: data.masterCarrierID,
            prodCodeId: data.carrierProducerCodeId,
            action: "ProducerAssociatedToModal",
          };

    localStorage.setItem(
      "groupedPage",
      tableRef.current.dataManager.currentPage,
    );

    localStorage.setItem(
      fieldName === "producerName"
        ? "employeeRedirectState"
        : "officeRedirectState",
      JSON.stringify(redirectState),
    );

    history.push({
      pathname: url,
    });

    globalThis.location.reload();
    let userTabs = [{ to: "" }];
    const tabsList = fieldName === "producerName" ? EmployeeTabs : OfficeTabs;

    for (const tabs of tabsList) {
      if (userPermissions.includes(tabs.permission)) {
        userTabs.push(tabs);
      }
    }

    userTabs.shift();
    const index = userTabs.findIndex((c) => c.to === url);
    setSelectedIndex(index);
  };

  return (
    <>
      <div className="w-full">
        <div className="p-2 space-y-4 mb-2 border-quinary">
          <div className="text-xs font-medium ">
            <div className="grid grid-flow-col grid-cols-3 gap-12 m-2">
              <div className="grid grid-cols-5 w-full items-center">
                <div className="col-span-2 expandedLabel fontExpand text-left">
                  Agency:
                </div>
                <div className="col-span-3 expandedData fontExpand">
                  {" "}
                  {getValue(data.brand)}
                </div>
              </div>
              <div className="grid grid-cols-5 w-full items-center">
                <div className="col-span-2 expandedLabel fontExpand text-left">
                  Code Level:
                </div>
                <div className="col-span-3 expandedData fontExpand">
                  {getValue(data.codeLevel)}
                </div>
              </div>
              <div className="grid grid-cols-5 w-full items-center">
                <div className="col-span-2 expandedLabel fontExpand text-left">
                  Is Active:
                </div>
                <div className="col-span-3 expandedData fontExpand">
                  {getActiveState(data.isActive)}
                </div>
              </div>
            </div>
            <div className="w-full border-b border-gray-200" />
            <div className="grid grid-flow-col grid-cols-3 gap-12 m-2">
              <div className="grid grid-cols-5 w-full items-center">
                <div className="col-span-2 expandedLabel fontExpand text-left">
                  Sub Code:
                </div>
                <div className="col-span-3 expandedData fontExpand">
                  {" "}
                  {getValue(data.producerSubCode)}
                </div>
              </div>
              <div className="grid grid-cols-5 w-full items-center">
                <div className="col-span-2 expandedLabel fontExpand text-left">
                  Carrier Program Name:
                </div>
                <div className="col-span-3 expandedData fontExpand">
                  {getValue(data.program)}
                </div>
              </div>
              <div className="grid grid-cols-5 w-full items-center">
                <div className="col-span-2 expandedLabel fontExpand text-left">
                  Is Suspended:
                </div>
                <div className="col-span-3 expandedData fontExpand">
                  {getSuspendedState(data.isSuspended)}
                </div>
              </div>
            </div>
            <div className="w-full border-b border-gray-200" />
            <div className="grid grid-flow-col grid-cols-3 gap-12 m-2">
              <div className="grid grid-cols-5 w-full items-center">
                <div className="col-span-2 expandedLabel fontExpand text-left">
                  M&A:
                </div>

                <div className="col-span-3 expandedData fontExpand truncate">
                  {getValue(data.mAproducerCode)}
                </div>
              </div>
              <div className="grid grid-cols-5 w-full items-center">
                <div className="col-span-2 expandedLabel fontExpand text-left">
                  Distribution Channel:
                </div>

                <div className="col-span-3 expandedData fontExpand truncate">
                  {getDistributionChannel(data)}
                </div>
              </div>
              <div className="grid grid-cols-5 w-full items-center">
                <div className="col-span-2 expandedLabel fontExpand text-left">
                  Franchise Type:
                </div>
                <div className="col-span-3 expandedData fontExpand">
                  {getValue(data.franchiseTypeName)}
                </div>
              </div>
            </div>
            <div className="w-full border-b border-gray-200" />
            <div className="grid grid-flow-col grid-cols-3 gap-12 m-2">
              <div className="grid grid-cols-5 w-full items-center">
                <div className="col-span-2 expandedLabel fontExpand text-left">
                  Office Code:
                </div>
                <div className="col-span-3 expandedData fontExpand">
                  {" "}
                  {getValue(data.officeCode)}
                </div>
              </div>
              <div className="grid grid-cols-5 w-full items-center">
                <div className="col-span-2 expandedLabel fontExpand text-left">
                  Store Number:
                </div>
                <div className="col-span-3 expandedData fontExpand">
                  {" "}
                  {getValue(data.storeNumber)}
                </div>
              </div>
              {data.associatedTo === "Office" ? (
                <div className="grid grid-cols-5 w-full items-center">
                  <div className="col-span-2 expandedLabel fontExpand text-left">
                    Associated To:
                  </div>
                  <div className="col-span-3 expandedData fontExpand">
                    {data.officeName ? (
                      <div
                        className="cursor-pointer"
                        onClick={() => {
                          onClickHandleLink("associatedTo", data);
                        }}
                      >
                        <span className="text-left underline text-blue-500">
                          {data.officeName}
                        </span>
                        <div className="">
                          <span className="text-left underline text-blue-500">
                            {data.address}
                            {", "} {data.city}
                            {", "} {data.state}
                          </span>
                        </div>{" "}
                      </div>
                    ) : (
                      getFallback()
                    )}
                  </div>
                </div>
              ) : (
                <div className="grid grid-cols-5 w-full items-center">
                  <div className="col-span-2 expandedLabel fontExpand text-left">
                    Producer:
                  </div>
                  <div className="col-span-3 expandedData fontExpand">
                    <ReactTooltip place="right" effect="solid" type="info" />
                    {renderProducerContent()}
                  </div>
                </div>
              )}{" "}
            </div>
            <div className="w-full border-b border-gray-200" />
            <div className="grid grid-flow-col grid-cols-3 gap-12 m-2">
              <div className="grid grid-cols-5 w-full items-center">
                <div className="col-span-2 expandedLabel fontExpand text-left">
                  Acquisition Name:
                </div>
                <div className="col-span-3 expandedData fontExpand">
                  {getValue(data.acquisitionName)}
                </div>
              </div>
              <div className="grid grid-cols-5 w-full items-center">
                <div className="col-span-2 expandedLabel fontExpand text-left">
                  Office Status Details:
                </div>
                <div className="col-span-3 expandedData fontExpand">
                  {getValue(data.officeStatusDetailsName)}
                </div>
              </div>
              <div className="grid grid-cols-5 w-full items-center">
                <div className="col-span-2 expandedLabel fontExpand text-left">
                  Related Office Code:
                </div>
                <div className="col-span-3 expandedData fontExpand">
                  {getValue(data.relatedOfficeCode)}
                </div>
              </div>
            </div>
            <div className="w-full border-b border-gray-200" />
            <div className="grid grid-flow-col grid-cols-3 gap-12 m-2">
              {" "}
              <div className="grid grid-cols-5 w-full items-center">
                <div className="col-span-2 expandedLabel fontExpand text-left">
                  Master Code Status:
                </div>
                <div className="col-span-3 expandedData fontExpand">
                  {" "}
                  {getCodeStatus(data.masterCodeStatus)}
                </div>
              </div>
              <div className="grid grid-cols-5 w-full items-center">
                <div className="col-span-2 expandedLabel fontExpand text-left">
                  Roll Up Code Status:
                </div>
                <div className="col-span-3 expandedData fontExpand">
                  {" "}
                  {getCodeStatus(data.rollUpCodeStatus)}
                </div>
              </div>{" "}
              <div className="grid grid-cols-5 w-full items-center">
                <div className="col-span-2 expandedLabel fontExpand text-left">
                  State Code:
                </div>
                <div className="col-span-3 expandedData fontExpand">
                  {" "}
                  {getValue(data.state)}
                </div>
              </div>
            </div>
            <div className="w-full border-b border-gray-200" />
            <div className="grid grid-flow-col grid-cols-3 gap-12 m-2">
              <div className="grid grid-cols-5 w-full items-center">
                <div className="col-span-2 expandedLabel fontExpand text-left">
                  Master Code:
                </div>
                <div className="col-span-3 expandedData fontExpand">
                  {getValue(data.masterCode)}
                </div>
              </div>
              <div className="grid grid-cols-5 w-full items-center">
                <div className="col-span-2 expandedLabel fontExpand text-left">
                  Roll Up Codes:
                </div>
                <div className="col-span-3 expandedData fontExpand">
                  {getValue(data.rollUpCode)}
                </div>
              </div>
              <div className="grid grid-cols-5 w-full items-center">
                <div className="col-span-2 expandedLabel fontExpand text-left">
                  Can Sell:
                </div>
                <div
                  ref={canSellRef}
                  className="col-span-3 expandedData fontExpand truncate"
                  {...(data?.crossSale
                    ? {
                        "data-tip": getListValue(data.crossSale),
                        "data-for": "crossSaleTooltip",
                      }
                    : {})}
                >
                  {getListValue(data?.crossSale)}
                </div>
                <ReactTooltip
                  place="right"
                  className="w-[450px] whitespace-normal bg-white"
                  id="crossSaleTooltip"
                  effect="solid"
                  border={true}
                  arrowColor="#0078d7"
                  borderColor="#0078d7"
                  backgroundColor="bg-blue-600"
                  textColor="#0078d7"
                />
              </div>
            </div>
            <div className="w-full border-b border-gray-200" />

            <div className="grid  grid-flow-col grid-cols-3 gap-12 m-2">
              <div className="grid grid-cols-5 w-full items-center">
                <div className="col-span-2 expandedLabel fontExpand text-left">
                  Mapped To CDRC:
                </div>
                <div className="col-span-3 expandedData fontExpand">
                  {getCdrcStatus(data)}
                </div>
              </div>
              <div className="grid grid-cols-5 w-full items-center">
                <div className="col-span-2 expandedLabel fontExpand text-left">
                  Mapped To Keeper:
                </div>
                <div className="col-span-3 expandedData fontExpand">
                  {data.keeperStatus}
                </div>
              </div>
              <div className="grid grid-cols-5 w-full items-center">
                <div className="col-span-2 expandedLabel fontExpand text-left">
                  Mapped To AL3:
                </div>
                <div className="col-span-3 expandedData fontExpand">
                  {data.aL3Status}
                </div>
              </div>
            </div>
            <div className="w-full border-b border-gray-200" />
            <div className="grid  grid-flow-col grid-cols-3 gap-12 m-2">
              <div className="grid grid-cols-5 w-full items-center">
                <div className="col-span-2 expandedLabel fontExpand text-left">
                  CDRC Last Execution:
                </div>
                <div className="col-span-3 expandedData fontExpand">
                  {getExecutionDate(data.cdrcLastExecutionDate)}
                </div>
              </div>
              <div className="grid grid-cols-5 w-full items-center">
                <div className="col-span-2 expandedLabel fontExpand text-left">
                  Keeper Last Execution:
                </div>
                <div className="col-span-3 expandedData fontExpand">
                  {getExecutionDate(data.keeperLastExecutionDate)}
                </div>
              </div>
              <div className="grid grid-cols-5 w-full items-center">
                <div className="col-span-2 expandedLabel fontExpand text-left">
                  AL3 Last Execution:
                </div>
                <div className="col-span-3 expandedData fontExpand">
                  {getExecutionDate(data.aL3LastExecutionDate)}
                </div>
              </div>
            </div>
            <div className="w-full border-b border-gray-200" />
            <div className="grid  grid-flow-col grid-cols-3 gap-12 m-2">
              {data.carrierName === "National General" && (
                <>
                  <div className="grid grid-cols-5 w-full items-center">
                    <div className="col-span-2 expandedLabel fontExpand text-left">
                      Agent ID:
                    </div>
                    <div className="col-span-3 expandedData fontExpand">
                      {getValue(data.princetonAgentCode)}
                    </div>
                  </div>
                  <div className="grid grid-cols-5 w-full items-center">
                    <div className="col-span-2 expandedLabel fontExpand text-left">
                      Master Agent ID:
                    </div>
                    <div className="col-span-3 expandedData fontExpand">
                      {getValue(data.masterAgentPrincetonId)}
                    </div>
                  </div>
                </>
              )}
            </div>
            {data.carrierName === "National General" && (
              <div className="w-full border-b border-gray-200" />
            )}
            <div className="grid grid-flow-col grid-cols-3 gap-12 m-2">
              <div className="grid grid-cols-5 w-full items-center">
                <div className="col-span-2 expandedLabel fontExpand text-left">
                  Line of Business:
                </div>
                <div className="col-span-3 expandedData fontExpand">
                  {" "}
                  {getValue(data.lineOfBusiness)}
                </div>
              </div>
              <div className="grid grid-cols-5 w-full items-center">
                <div className="col-span-2 expandedLabel fontExpand text-left">
                  Issued To:
                </div>
                <ReactTooltip
                  className="w-1/2"
                  place="bottom"
                  effect="solid"
                  type="info"
                />{" "}
                <div
                  className="col-span-3 expandedData fontExpand truncate"
                  data-tip={data.issuedTo}
                >
                  {getValue(data.issuedTo)}
                </div>
              </div>
              <div className="grid grid-cols-5 w-full items-center">
                <div className="col-span-2 expandedLabel fontExpand text-left">
                  MGA:
                </div>
                <div className="col-span-3 expandedData fontExpand">
                  {getValue(data.mga)}
                </div>
              </div>
            </div>
            <div className="w-full border-b border-gray-200" />
            <div className="grid grid-flow-col grid-cols-3 gap-12 m-2">
              <div className="grid grid-cols-5 w-full items-center ">
                <div className="col-span-2 expandedLabel fontExpand text-left">
                  Producer Code Type:
                </div>
                <div className="col-span-3 expandedData fontExpand">
                  {" "}
                  {getValue(data.producerCodeTypesName)}
                </div>
              </div>
              <div className="grid grid-cols-5 w-full items-center ">
                <div className="col-span-2 expandedLabel fontExpand text-left">
                  Billing:
                </div>
                <div className="col-span-3 expandedData fontExpand">
                  {getValue(data.billingName)}
                </div>
              </div>
              <div className="grid grid-cols-5 w-full items-center">
                <div className="col-span-2 expandedLabel fontExpand text-left">
                  Created By:
                </div>
                <div className="col-span-3 expandedData fontExpand">
                  {" "}
                  {getValue(data.createdBy)}
                </div>
              </div>
            </div>
            <div className="w-full border-b border-gray-200" />
            <div className="grid grid-cols-3 gap-12 m-2">
              <div className="grid grid-cols-5 w-full items-center ">
                <div className="col-span-2 expandedLabel fontExpand text-left">
                  Created Date:
                </div>
                <div className="col-span-3 expandedData fontExpand">
                  {getDateValue(data.createdDate)}
                </div>
              </div>
              <div className="grid grid-cols-5 w-full items-center ">
                <div className="col-span-2 expandedLabel fontExpand text-left">
                  Modified By:
                </div>
                <div className="col-span-3 expandedData fontExpand">
                  {" "}
                  {getValue(data.modifiedBy)}
                </div>
              </div>
              <div className="grid grid-cols-5 w-full items-center">
                <div className="col-span-2 expandedLabel fontExpand text-left">
                  Modified Date:
                </div>
                <div className="col-span-3 expandedData fontExpand">
                  {getDateValue(data.modifiedDate)}
                </div>
              </div>
            </div>
            <div className="w-full border-b border-gray-200" />
            <div className="grid grid-cols-3 gap-12 m-2">
              <div className="grid grid-cols-5 w-full items-start ">
                <div className="col-span-2 expandedLabel fontExpand text-left">
                  In Production:
                </div>
                <div className="col-span-3 expandedData fontExpand">
                  {getProductionState(data.isInProduction)}
                </div>
              </div>

              <div className="grid grid-cols-5 w-full items-start">
                <div className="col-span-2 expandedLabel fontExpand text-left">
                  Carrier Status:
                </div>
                <div className="col-span-3 expandedData fontExpand">
                  {getCarrierStatusLabel(data.carrierStatus)}
                </div>
              </div>

              {data.masterCarrierID === 60 ? (
                <div className="grid grid-cols-5 w-full items-center ">
                  <div className="col-span-2 expandedLabel fontExpand text-left">
                    Progressive Code:
                  </div>
                  <div className="col-span-3 expandedData fontExpand">
                    {data.progressiveCode}
                  </div>
                </div>
              ) : (
                <div className="grid grid-cols-5 w-full items-start ">
                  <div className="col-span-2 expandedLabel fontExpand text-left">
                    Notes:
                  </div>
                  <div className="col-span-3 expandedData fontExpand">
                    {getPreNotes(data.notes)}
                  </div>
                </div>
              )}
            </div>

            {data.masterCarrierID === 60 && (
              <>
                <div className="w-full border-b border-gray-200" />

                <div className="grid grid-cols-3 gap-12 m-2">
                  <div className="grid grid-cols-5 w-full items-start ">
                    <div className="col-span-2 expandedLabel fontExpand text-left">
                      Notes:
                    </div>
                    <div className="col-span-3 expandedData fontExpand">
                      {getSimplePreNotes(data.notes)}
                    </div>
                  </div>
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    </>
  );
};
